import React from 'react';
const Navbar = () => {
  return <nav className="w-full bg-[#FFFCF8] py-4 px-6 md:px-12 lg:px-24 flex justify-between items-center border-b border-[#E8DFD5]" data-id="element-81">
      <div className="text-2xl font-bold text-[#C17A47]" data-id="element-82">RecetasExpress</div>
      <div className="flex space-x-4" data-id="element-83">
        <button className="px-4 py-2 text-[#C17A47] hover:text-[#A05A27] font-medium" data-id="element-84">
          Inicio
        </button>
        <button className="px-4 py-2 text-[#C17A47] hover:text-[#A05A27] font-medium" data-id="element-85">
          Recetas
        </button>
        <button className="px-4 py-2 bg-[#C17A47] text-white rounded-md hover:bg-[#A05A27]" data-id="element-86">
          Comprar
        </button>
      </div>
    </nav>;
};
export default Navbar;